import FancyTreeViewModel from '@/ViewModels/Controls/FancyTreeViewModel';
import PanelBarItemViewModel from '@/ViewModels/Controls/PanelBarItemViewModel';
import NavigationViewModel from '@/ViewModels/Views/NavigationViewModel';

export default class NavigationTreeService {

    public static getFancyTree(): Fancytree.Fancytree {
        let navigationDOM = $('[data-view=Navigation]')[0];
        if (navigationDOM) {
            let koData = ko.dataFor(navigationDOM);
            if (koData && koData.viewModel) {
                let navigationViewModel = koData.viewModel as NavigationViewModel;
                let panelBarItem = navigationViewModel.panelBar.items()[0] as PanelBarItemViewModel;
                let viewModel = panelBarItem.treeView.tree as FancyTreeViewModel;
                return $.ui.fancytree.getTree("div[data-locator='" + viewModel.locator() + "'] .ui-fancytree");
            }
        }
        return null;
    }

    public static expandAll(): void {
        let fancyTree = this.getFancyTree();
        fancyTree.expandAll();
    }

    public static collapseAll(): void {
        let fancyTree = this.getFancyTree();
        fancyTree.expandAll(false);
    }
}